import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';

import ContentPage from '../components/ui/ContentPage';

const REGULATIONS = [
  {
    code: 'EUDR · Regulamento (UE) 2023/1115',
    title: 'Cadeas de subministración libres de deforestación',
    text: 'LeyroChain rexistra a xeolocalización (GeoJSON) e a información de produción para cada animal. Os exportadores de carne descargan a Due Diligence Statement (DDS) automaticamente cando preparan unha exportación.',
  },
  {
    code: 'PEPA · Real Decreto 992/2022',
    title: 'Plan estratéxico nacional de prevención e control de antimicrobianos',
    text: 'Cada medicación rexistrada na app móbil queda na cadea, indicando principio activo, vía e tempo de espera. As autoridades sanitarias poden consultar o histórico inalterable.',
  },
  {
    code: 'eIDAS · Regulamento (UE) 910/2014',
    title: 'Sinatura electrónica avanzada',
    text: 'As sinaturas ECDSA P-256 dos veterinarios sobre eventos sanitarios constitúen sinatura electrónica avanzada conforme ao Art. 3.11. Non substitúen o certificado dixital colexial para actos oficiais.',
  },
  {
    code: 'RGPD · Regulamento (UE) 2016/679',
    title: 'Protección de datos persoais',
    text: 'Detalle en Política de privacidade. Resumo: tratamos só o imprescindible, respondemos en 30 días, e os hashes blockchain non conteñen datos persoais.',
  },
  {
    code: 'Lei 8/2003 · Sanidade animal',
    title: 'Notificacións oficiais',
    text: 'Mantemos rexistro paralelo, non substitutivo. Os actos oficiais (declaración de enfermidades, movemento entre comarcas) seguen indo a SITRAN.',
  },
];

export default function CompliancePage(): JSX.Element {
  return (
    <ContentPage
      title="Cumprimento normativo"
      intro="Resumo das regulacións europeas e estatais que cumprimos por deseño. Cada bloque é unha das pedras angulares do noso valor: información trazable, verificable e auditable."
      category="Información"
    >
      <ul className="not-prose space-y-4">
        {REGULATIONS.map((r) => (
          <li
            key={r.code}
            className="flex items-start gap-3 border border-border rounded-2xl p-5 bg-white"
          >
            <CheckCircle2 size={22} className="text-rauxa mt-0.5 shrink-0" />
            <div className="flex-1">
              <div className="text-xs uppercase tracking-wide text-muted font-semibold">
                {r.code}
              </div>
              <h3 className="font-semibold text-dark mt-0.5 mb-1">{r.title}</h3>
              <p className="text-sm text-muted leading-relaxed">{r.text}</p>
            </div>
          </li>
        ))}
      </ul>

      <h2>Auditorías externas</h2>
      <p>
        A nosa anclaxe diaria na blockchain Polygon é pública e verificable por calquera. Cada
        Merkle root publícase en{' '}
        <a href="https://polygonscan.com" target="_blank" rel="noreferrer">
          polygonscan.com
        </a>{' '}
        e podes comprobar a inclusión dun evento usando a páxina de verificación QR.
      </p>

      <h2>Contacto regulatorio</h2>
      <p>
        Autoridades, auditores e consultores: escribide a{' '}
        <Link to="/marketplace/contacto" className="text-rauxa font-semibold hover:underline">
          contacto
        </Link>{' '}
        ou a <a href="mailto:cumprimento@leyro.es">cumprimento@leyro.es</a>.
      </p>
    </ContentPage>
  );
}
